package pwgs.ui.scenes.userreportsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AUserReportsControllerFe(props: pwgs.ui.scenes.userreportsscene.UserReportsSceneProps, scene: MUserReportsScene)
 : AController<pwgs.ui.scenes.userreportsscene.UserReportsSceneProps, pwgs.ui.scenes.userreportsscene.UserReportsSceneModel, UserReportsSceneState>(props, scene) {

    val backend = UserReportsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class UserReportsControllerBeProxy(private val controller: AUserReportsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.userreportsscene.UserReportsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.userreportsscene.UserReportsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.userreportsscene.UserReportsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.userreportsscene.UserReportsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.userreportsscene.UserReportsSceneModel.serializer())
        }
    }

}
